<template>
  <div id="wumpus">
    <div id="wumpus-image"></div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
#wumpus {
  display: flex;
  background-color: white;
  position: relative;
  margin-top: 2px;
  width: 100%;
  height: 100%;
  #wumpus-image {
    flex: 0 1 auto;
    width: 421px;
    height: 218px;
    margin: auto;
    background-image: url('/static/images/wumpus.svg');
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Context/Wumpus.vue